/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import getScrollableParent from './support/get-scrollable-parent';
import disableRubberBand from './support/disable-rubber-band';
var scrollableParent = null;
var clientY;

var preventDefault = function preventDefault(event) {
  if (event.cancelable && !event.defaultPrevented) {
    event.preventDefault();
  }
};

var handleTouchStart = function handleTouchStart(event) {
  if (event.targetTouches.length === 1) {
    scrollableParent = getScrollableParent(event.target);
    clientY = event.targetTouches[0].clientY;
  } else {
    scrollableParent = null;
    clientY = null;
  }
};

var handleTouchMove = function handleTouchMove(event) {
  if (!scrollableParent) {
    preventDefault(event);
  } else {
    disableRubberBand(scrollableParent, event, clientY);
  }
};

var onWheel = function onWheel(event) {
  var localScrollableParent = getScrollableParent(event.target);

  if (!localScrollableParent) {
    preventDefault(event);
  } else {
    var scrollTop = localScrollableParent.scrollTop,
        scrollHeight = localScrollableParent.scrollHeight,
        offsetHeight = localScrollableParent.offsetHeight;

    if (event.deltaY <= 0 && localScrollableParent.scrollTop === 0) {
      preventDefault(event);
    } else if (event.deltaY >= 0 && scrollTop === scrollHeight - offsetHeight) {
      preventDefault(event);
    }
  }
};

var onScroll = function onScroll(event) {
  preventDefault(event);
};

export var blockScrolling = function blockScrolling(element) {
  element.addEventListener('touchstart', handleTouchStart, false);
  element.addEventListener('touchmove', handleTouchMove, false);
  window.onwheel = document.onwheel = onWheel;
  window.onscroll = onScroll;
};
export var unblockScrolling = function unblockScrolling(element) {
  element.removeEventListener('touchstart', handleTouchStart);
  element.removeEventListener('touchmove', handleTouchMove);
  window.onwheel = document.onwheel = null;
  window.onscroll = null;
};